export const state = () => {
	return {
		program: {},
		ttl_program: null,
		cache_duration_program: 1800000,
		cache_key_program: '',
	}
}

function isInCacheProgram(state, companyId) {
	if (state.cache_key_program !== buildCacheKeyProgram(companyId)) {
		return false
	}
	if (state.ttl_program === null || state.ttl_program < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyProgram(companyId) {
	return 'company:' + companyId + ':vip-tiers-program'
}

export const actions = {
	async list({ state, commit }, { companyId }) {
		if (isInCacheProgram(state, companyId)) {
			return state.program
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/programs/`)
			.then((res) => {
				commit('setProgram', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCacheProgram')
				throw err
			})
	},

	async partial_update({ dispatch, commit }, { companyId, program, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/vip-tiers/programs/${program.id}/`, {
				method: 'PATCH',
				body: data,
			})
			.then(async () => {
				commit('invalidateCacheProgram')
				return await dispatch('list', { companyId })
			})
			.catch((err) => {
				commit('invalidateCacheProgram')
				throw err
			})
	},
}

export const mutations = {
	setProgram(state, { data, companyId }) {
		state.program = data
		state.ttl_program = Date.now() + state.cache_duration_program
		state.cache_key_program = buildCacheKeyProgram(companyId)
	},

	clearCacheProgram(state) {
		state.rewards = []
		state.ttl_program = null
		state.cache_key_program = ''
	},

	invalidateCacheProgram(state) {
		state.ttl_program = null
	},
}

export const getters = {
	isExpirationRolling: (state) => state.program.expiration === 3,
}
